module.exports = __webpack_public_path__ + "static/media/extend button.fc2ff17e.svg";